module.exports = __webpack_public_path__ + "static/creatorweek22BG-73f22972d0fb0fd508664a9e0e268b48.jpg";